import React from 'react';

import { InputMask } from 'primereact/inputmask';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import {wrapComponent, extract} from "../utils";
import BaseInput from "./BaseFields/BaseInput";

export const Phone = (props: FormPageFieldComponentProps) => {
  if(!props.extraConfig?.mask)props.extraConfig.mask = "(999) 999-9999"
  return <BaseInput {...props} />
  // const comp = <InputMask {...extract({mask}, extraConfig, restProps)} mask={ mask} placeholder={restProps.placeholder || mask}/>;
  // return wrapComponent( comp, extraConfig)
};

export const PhoneFormik = withFormikFormControl()(Phone);

export default PhoneFormik;
